// external pdf logic from global-resources
// https://develop.ampf.com/bitbucket/projects/MCC/repos/cwp-global-resources/browse/ameriprise-custom/misc.js?at=cd4badd37ea476f028505ccc65bdbac38da57945#18,28-31,36
export default function () {
  const links = [...document.querySelectorAll('a[href]')].filter((element) =>
    /\.pdf/i.test(element.getAttribute('href'))
  )

  links.forEach((linkElement) => {
    linkElement.setAttribute('rel', 'external')
    linkElement.setAttribute('target', '_blank')
  })
}
